import { AlertTriangle, Calendar, Loader } from 'lucide-react';
import { useLegalContent } from '../../utils/legalContent';

export const DisclaimerModal = () => {
  const { content, loading, error } = useLegalContent();

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader className="h-8 w-8 animate-spin text-brand" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="p-6 text-center">
        <p className="text-status-error">Failed to load disclaimer.</p>
      </div>
    );
  }

  const disc = content.disclaimer;

  return (
    <div className="space-y-6 p-4 sm:p-6">
      <div className="rounded-xl border border-subtle/80 bg-elevated/80 p-4 sm:p-6">
        <div className="mb-3 flex items-center gap-3">
          <AlertTriangle className="h-6 w-6 shrink-0 text-status-warning" />
          <h3 className="text-lg font-semibold text-th-primary">{disc.title}</h3>
        </div>
        <div className="flex items-center gap-2 text-sm text-th-secondary">
          <Calendar className="h-4 w-4 shrink-0" />
          <span>Last updated: {content.lastUpdated}</span>
        </div>
      </div>

      <div className="space-y-6 rounded-xl border border-subtle/80 bg-elevated/50 p-4 sm:p-6">
        {disc.sections.map((section, index) => (
          <div key={index}>
            <h4 className="mb-2 text-base font-semibold text-th-primary">{section.title}</h4>
            <p className="text-sm leading-relaxed text-th-secondary">{section.content}</p>
            {section.list && (
              <ul className="ml-4 mt-2 list-disc space-y-1 text-sm text-th-secondary">
                {section.list.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-subtle/80 bg-elevated p-4 sm:p-6">
        <h4 className="mb-2 text-base font-semibold text-th-primary">{disc.contact.title}</h4>
        <p className="mb-2 text-sm text-th-secondary">{disc.contact.content}</p>
        <p className="text-sm text-th-primary">
          Email:{' '}
          <a href={`mailto:${disc.contact.email}`} className="text-brand underline hover:text-brand-hover">
            {disc.contact.email}
          </a>
        </p>
      </div>
    </div>
  );
};
